import React from 'react';
import classnames from 'classnames';
import useStyles from './LinkText.styles';
import { ILinkTextProps } from './LinkText.types';

const LinkTextComponent = ({ highlight, name }: ILinkTextProps) => {
  const { linkText, menuHighlight } = useStyles();
  return (
    <div className={classnames(linkText, { [menuHighlight]: highlight })} title={name}>
      {name}
    </div>
  );
};

export default LinkTextComponent;
